module.exports={
  "name": "aframe",
  "version": "0.3.2",
  "description": "Building blocks for the VR Web",
  "homepage": "https://aframe.io/",
  "main": "dist/aframe.js",
  "scripts": {
    "browserify": "browserify src/index.js -s 'AFRAME' -p browserify-derequire",
    "build": "mkdirp build/ && npm run browserify -- --debug -t [envify --INSPECTOR_VERSION dev] -o build/aframe.js",
    "codecov": "codecov",
    "dev": "npm run build && cross-env INSPECTOR_VERSION=dev node ./scripts/budo -t envify",
    "dist": "npm run dist:min && npm run dist:max",
    "dist:max": "npm run browserify -s -- --debug -t [envify --INSPECTOR_VERSION dev] | exorcist dist/aframe.js.map > dist/aframe.js",
    "dist:min": "npm run browserify -s -- --debug -t [envify --INSPECTOR_VERSION dev] -p [minifyify --map aframe.min.js.map --output dist/aframe.min.js.map] -o dist/aframe.min.js",
    "dist:release": "npm run dist:release:min && npm run dist:release:max",
    "dist:release:max": "npm run browserify -s -- --debug | exorcist dist/aframe-v0.3.0.js.map > dist/aframe-v0.3.0.js",
    "dist:release:min": "npm run browserify -s -- --debug -p [minifyify --map aframe-v0.3.0.min.js.map --output dist/aframe-v0.3.0.min.js.map] -o dist/aframe-v0.3.0.min.js",
    "docs": "markserv --dir docs --port 9001",
    "ghpages": "ghpages -p gh-pages/",
    "lint": "semistandard -v | snazzy",
    "precommit": "npm run lint",
    "preghpages": "npm run dist && rimraf gh-pages && mkdirp gh-pages && cp -r {.nojekyll,dist,lib,examples,index.html,style} gh-pages/. 2>/dev/null || : && git checkout dist/ && replace 'build/aframe.js' 'dist/aframe.min.js' gh-pages/ -r --silent",
    "release:bump": "npm run dist && git commit -am 'bump dist' && npm version patch --preminor",
    "release:push": "npm login && npm publish && git push --follow-tags",
    "start": "npm run dev",
    "test": "karma start ./tests/karma.conf.js",
    "test:firefox": "karma start ./tests/karma.conf.js --browsers Firefox",
    "test:chrome": "karma start ./tests/karma.conf.js --browsers Chrome",
    "test:ci": "TEST_ENV=ci karma start ./tests/karma.conf.js --single-run --browsers Firefox",
    "version": "npm run dist"
  },
  "repository": "aframevr/aframe",
  "license": "MIT",
  "dependencies": {
    "browserify-css": "^0.8.2",
    "debug": "^2.2.0",
    "deep-assign": "^2.0.0",
    "document-register-element": "dmarcos/document-register-element#8ccc532b7",
    "object-assign": "^4.0.1",
    "present": "0.0.6",
    "promise-polyfill": "^3.1.0",
    "style-attr": "^1.0.2",
    "three": "^0.81.2",
    "tween.js": "^15.0.0",
    "webvr-polyfill": "0.9.15"
  },
  "devDependencies": {
    "browserify": "^13.1.0",
    "browserify-derequire": "^0.9.4",
    "browserify-istanbul": "^2.0.0",
    "budo": "^9.2.0",
    "chai": "^3.5.0",
    "chai-shallow-deep-equal": "^1.4.0",
    "codecov": "^1.0.1",
    "envify": "^3.4.1",
    "exorcist": "^0.4.0",
    "ghpages": "0.0.8",
    "husky": "^0.11.7",
    "istanbul": "^0.4.5",
    "karma": "^1.3.0",
    "karma-browserify": "^5.1.0",
    "karma-chai-shallow-deep-equal": "0.0.4",
    "karma-chrome-launcher": "^2.0.0",
    "karma-coverage": "^1.1.1",
    "karma-env-preprocessor": "^0.1.1",
    "karma-firefox-launcher": "^1.0.0",
    "karma-mocha": "^1.1.1",
    "karma-mocha-reporter": "^2.1.0",
    "karma-sinon-chai": "^1.2.4",
    "lolex": "^1.5.1",
    "markserv": "0.0.20",
    "minifyify": "^7.3.3",
    "mkdirp": "^0.5.1",
    "mocha": "^3.0.2",
    "mozilla-download": "^1.1.1",
    "open": "0.0.5",
    "replace": "^0.3.0",
    "rimraf": "^2.5.4",
    "semistandard": "^9.0.0",
    "sinon": "^1.17.5",
    "sinon-chai": "^2.8.0",
    "snazzy": "^5.0.0",
    "uglifyjs": "^2.4.10"
  },
  "link": true,
  "browserify": {
    "transform": [
      "browserify-css",
      "envify"
    ]
  },
  "semistandard": {
    "ignore": [
      "build/**",
      "dist/**",
      "examples/**/shaders/*.js",
      "**/vendor/**"
    ]
  },
  "keywords": [
    "3d",
    "aframe",
    "cardboard",
    "components",
    "oculus",
    "three",
    "three.js",
    "rift",
    "vive",
    "vr",
    "web-components",
    "webvr"
  ],
  "browserify-css": {
    "minify": true
  },
  "engines": {
    "node": ">= 4.6.0",
    "npm": "^2.15.9"
  }
}
